/**
 * covid19_dashboard copyright © 2020
 * Created by mauromarini on 18/07/2020
 * Repository: http://github.com/marinimau/covid19_dashboard
 * Location: Baratili San Pietro
 */

const Colors = {
    /** LIGHT MODE **/
    main: '#1479FF',
    mainTransparent: 'rgba(20,121,255,0.1)',
    basic: '#1C1C1E',
    basicNotes: 'rgba(255,255,255,0.9)',
    icons: 'rgba(28,28,30,0.4)',
    navigationInactive: 'rgba(28,28,30,0.7)',
    basicTransparent: 'rgba(25,59,104,0.1)',
    basicShadow:'rgba(25,59,104,0.33)',
    background: '#f0f2f5',
    title: '#000',
    borders: 'rgba(101,101,101,0.25)',
    basicElevation: '#FFFFFF',
    accent1: '#14D2FF',
    accent2: '#14A5FF',
    accent3: '#14EBFF',
    axis: '#E4E4E4',
    bars: '#1479FF',
    navigationOverlay: 'rgba(0,0,0,0.1)',
    drawerSelectedText: '#1C1C1E',
    drawerSelectedBackground: 'rgba(25,59,104,0.1)',
    /** DARK MODE **/
    darkMode_main: '#0f63d2',
    darkMode_mainTransparent: 'rgba(24,97,195,0.1)',
    darkMode_title: '#fff',
    darkMode_basic: '#989899',
    darkMode_basicNotesLight: '#fff',
    darkMode_basicNotesText: '#000',
    darkMode_basicNotes: '#3a3b3c',
    darkMode_icons: 'rgba(202,202,202,0.4)',
    darkMode_navigationInactive: 'rgba(202,202,202,0.7)',
    darkMode_basicTransparent: 'rgba(136,136,136,0.1)',
    darkMode_basicShadow:'rgba(0,0,0,1)',
    darkMode_basicElevation: '#1c1c1e',
    darkMode_background: '#000', //'#18191a',
    darkMode_accent1: '#14D2FF',
    darkMode_accent2: '#14A5FF',
    darkMode_accent3: '#14EBFF',
    darkMode_axis: '#E4E4E4',
    darkMode_bars: '#1479FF',
    darkMode_drawerSelectedText: '#bebebe',
    darkMode_drawerSelectedBackground: '#3a3b3c',
};

export default Colors;
